import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
export default () => {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (discussion.canChangeLanguage()) {
      items.add('language', m(Button, {
        icon: "fas fa-globe",
        onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/LanguageDiscussionModal', webpackMode: 'lazy-once' */ './components/LanguageDiscussionModal'), {
          discussion
        })
      }, app.translator.trans('fof-discussion-language.forum.discussion_controls.change_language_button')));
    }
  });
};flarum.reg.addChunkModule('401', '301', 'fof-discussion-language', 'forum/components/LanguageDiscussionModal');